import Image from 'next/image'

export function FikaigoBrandLogo() {
  return (
    <Image alt="brand-logo" className="mx-auto" height={192} priority src="/logo.svg" width={220} />
  )
}
